/** Container width (px) below which banners switch to the default (column) layout. */
export const BANNER_COLUMN_BREAKPOINT_PX = 420;